import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Router } from "./Router/Router";

export const App = () => (
  <BrowserRouter>
    <Router />
  </BrowserRouter>
);

export default App;
